<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>

			<el-container>
				<slider />

				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Document to Be Obsoleted
							</div>

							<div class="page_main">
								<div class="page-container">
									<el-form
										ref="formRef"
										:model="form"
										:rules="rules"
										label-position="top"
										class="doc-form"
									>
										<!-- Document Number -->
										<el-form-item label="Document Number">
											<el-link type="primary" :underline="true">
												{{ form.ref }}
											</el-link>
										</el-form-item>

										<el-form-item label="Document Type">
											<el-input v-model="form.leixing_name" disabled />
										</el-form-item>

										<el-form-item label="Revision">
											<el-input v-model="form.vnumber" disabled />
										</el-form-item>

										<el-form-item label="Document Name">
											<el-input v-model="form.vname" disabled />
										</el-form-item>

										<el-form-item label="Company">
											<el-input v-model="form.leixing_name" disabled />
										</el-form-item>

										<el-form-item label="Department">
											<el-input v-model="form.departments_name" disabled />
										</el-form-item>

										<el-form-item label="Document File">
											<div
												class="file-name"
												@click="viewFile(form.fileUrl)"
											>
												{{ form.fileName }}
											</div>
										</el-form-item>

										<el-form-item
											label="Reason for Obsolescence"
											prop="refuse_reason"
										>
											<el-input
												v-model="form.refuse_reason"
												type="textarea"
												:rows="8"
												placeholder="Please enter the reason for obsolescence."
											/>
										</el-form-item>
									</el-form>

									<!-- Action Buttons -->
									<div class="btn_box">
										<van-button
											class="btn_el"
											type="default"
											round
											@click="handleCancel"
										>
											Cancel
										</van-button>

										<van-button
											class="btn_el"
											round
											color="linear-gradient(to right, #7BC1FF, #4886FF)"
											@click="handleSubmit"
										>
											Save
										</van-button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>

		<!-- Loading -->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
	</div>
</template>

<script>
import { resourcesLeixingList } from '@/api/docManage/configureDocControl/index';
// import { companyList } from '@/api/system/company';
import { departmentsList } from '@/api/system/department';
import {
	resourcesVersionDetail,
	resourcesAdd
} from '@/api/docManage/changeRequest/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			form: {
				leixing_id: '',
				leixing_name: '',
				ref: '',
				vnumber: '',
				vname: '',
				company_id: '',
				company_name: '',
				departments_id: '',
				departments_name: '',
				vdesc: '',
				fileName: '',
				fileUrl: '',
				selectedFile: '',
				refuse_reason: '',
				old_vid: null
			},
			rules: {
				refuse_reason: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
			}
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		//请求旧文件详情
		resourcesVersionDetail({ vid: that.$route.query.old_vid }).then(res3 => {
			if(res3.code == 200) {
				that.form = {
					leixing_id: res3.data.leixing_id,
					leixing_name: res3.data.leixing_name,
					ref: res3.data.ref,
					vnumber: res3.data.vnumber,
					vname: res3.data.vname,
					company_id: res3.data.company_id,
					company_name: res3.data.company_name,
					departments_id: res3.data.departments_id,
					departments_name: res3.data.departments_name,
					vdesc: res3.data.vdesc,
					fileName: res3.data.image_info.name,
					fileUrl: res3.data.image_info.url,
					selectedFile: res3.data.image_info.id,
					refuse_reason: ''
				};
				if(that.$route.query.type == 'edit') {
					//编辑
					that.form.refuse_reason = res3.data.refuse_reason;
					that.form.old_vid = res3.data.oldinfo.vid;
				}
			}
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	methods: {
		//提交
		handleSubmit() {
			let that = this;
			that.$refs.formRef.validate((valid) => {
				if(!valid) return;
				let query = {
					id: that.$route.query.oid,
					operation: 3,
					company_id: that.form.company_id,
					departments_id: that.form.departments_id,
					leixing_id: that.form.leixing_id,
					ref: that.form.ref,
					vname: that.form.vname,
					vdesc: that.form.vdesc,
					vnumber: that.form.vnumber,
					image_id: that.form.selectedFile,
					refuse_reason: that.form.refuse_reason,
					flow_type: 'resources_update'
				};
				if(that.$route.query.type == 'edit') {
					//编辑
					query.old_vid = that.form.old_vid;
					query.vid = that.$route.query.old_vid;
				}else {
					//添加
					query.old_vid = that.$route.query.old_vid;
					query.vid = '';
				}
				// console.log(query);
				// return false;
				that.$toast.loading({ duration: 0, forbidClick: true });
				resourcesAdd(query).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						setTimeout(() => {
							that.$router.push({ path: '/task-list' });
						}, 800);
					}
				});
			});
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
		//查看文件
		viewFile(value) {
			window.open(value);
		}
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
	.btn_box{
		text-align: center;
		.btn_el{
			margin-left: 10px;
			padding: 12px 24px;
			.van-button__text{
				font-size: 16px;
			}
		}
	}
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}
::v-deep .btn span {
  text-decoration: underline;
}

.page-container {
  min-height: 100vh;
  padding: 12px 14px 30px;
  box-sizing: border-box;
}

.doc-form {
  width: 100%;
}

::v-deep .el-form-item {
  margin-bottom: 14px;
}

::v-deep .el-form-item__label {
  font-size: 14px;
  color: #333;
  line-height: 20px;
  padding-bottom: 6px;
  font-weight: 600;
}

::v-deep .el-input__inner {
  height: 42px;
  line-height: 42px;
  border-radius: 6px;
  /* background: #eef1f5; */
  border: 1px solid #cfcfcf;
  color: #333;
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #e9edf2;
  color: #333;
}

::v-deep .el-select .el-input__inner {
  background: #fff;
}

.full-width {
  width: 100%;
}

.required-star {
  color: #f56c6c;
  margin-left: 2px;
}

.dept-row {
  display: flex;
  align-items: center;
}

.dept-input {
  flex: 1;
  margin-right: 0;
}

.dept-row .el-button {
  margin-left: -1px;
  height: 42px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 0 18px;
}

::v-deep .el-link {
  font-size: 16px;
  font-weight: 500;
}

::v-deep .el-link--inner {
  word-break: break-all;
}

.upload-doc-wrapper {
  width: 100%;
  margin-bottom: 40px;
  box-sizing: border-box;
}

.upload-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 14px;
  font-weight: 500;
}

.upload-limit {
  color: #666;
  font-weight: 400;
}

.upload-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.doc-upload {
  flex-shrink: 0;
}

.select-btn {
  height: 44px;
  border: none;
  border-right: 1px solid #dcdfe6;
  border-radius: 0;
  background: #f5f7fa;
  color: #333;
  padding: 0 20px;
}

.select-btn:hover,
.select-btn:focus {
  background: #eef1f6;
  color: #333;
}

.file-name {
  flex: 1;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  font-size: 15px;
  color: #333;
  background: #f5f7fa;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-name.placeholder {
  color: #999;
}

.divider {
  height: 1px;
  background: #d9d9d9;
  margin: 28px 0 20px;
}

.form-actions {
  display: flex;
  align-content: center;
  justify-content: center;
  gap: 12px;
}
</style>

